(function () {
  'use strict';
  var BauBundleInit = {
    start: function () {
      var P = window.BauBundleProducts, S = window.BauBundleState, R = window.BauBundleRenderer, E = window.BauBundleEvents;
      if (!P || !S || !R || !E) { console.error('[BauBundle] Missing modules'); return; }
      P.init().then(function () {
        S.init(); R.init('#bau-bundle-root'); E.init();
        window.dispatchEvent(new CustomEvent('bau-bundle:ready'));
      }).catch(function (err) { console.error('[BauBundle] Init failed:', err); });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { BauBundleInit.start(); });
  else BauBundleInit.start();
  window.BauBundleInit = BauBundleInit;
})();
